exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-table[data-v-31ac07a7]{height:500px;overflow-y:scroll}table tr th[data-v-31ac07a7]{top:0;position:-webkit-sticky;position:sticky;background-color:#dee2e6}table tr td[data-v-31ac07a7]{cursor:pointer}.selected[data-v-31ac07a7]{background-color:#dee2e6}.red[data-v-31ac07a7]{color:red}", ""]);

// exports
